<template>
  <slot
    name="content"
    :showQuickResAdditionalFields="showQuickResAdditionalFields"
    :careHomeQuickResponseRoomsChange="careHomeQuickResponseRoomsChange"
  >
  </slot>
</template>
<script setup>

import {ref} from 'vue'

const showQuickResAdditionalFields = ref(false);

const careHomeQuickResponseRoomsChange = (e) =>{
  showQuickResAdditionalFields.value = e.target.value !== 'Yes';
}

</script>
